import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import SSOFormComponent from './sso-form.component';

ComponentsFactory.getInstance().define('sso-form', SSOFormComponent);
